module.exports = "<div ng-if=\"$ctrl.canView()\">\r\n    <div class=\"heading-2 pt-3\">\r\n        <span translate>Group Memberships</span>\r\n    </div>\r\n    <div>\r\n        <span ng-repeat=\"retailerGroup in $ctrl.retailerGroups\">\r\n            <a ui-sref=\"retailerGroups.view({ id: retailerGroup.reportingGroupOid })\">{{ retailerGroup.name }}</a><span ng-if=\"!$last\">, </span>\r\n        </span>\r\n        <span ng-if=\"$ctrl.retailerGroups.length === 0\">\r\n          ---\r\n        </span>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/user/components/group-memberships/user-group-memberships.html
// module id = 1769
// module chunks = 0